import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

export const useSessionPersistence = () => {
  const { isAuthenticated, user } = useAuth();
  const location = useLocation();

  useEffect(() => {
    // Validate session on route changes - no action needed when valid
    void (isAuthenticated && user);
  }, [location.pathname, isAuthenticated, user]);

  // Handle page visibility changes (when user switches tabs/windows)
  useEffect(() => {
    const handleVisibilityChange = () => {
      // Page became visible again - session validation handled by auth context
      void (!document.hidden && isAuthenticated);
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    };
  }, [isAuthenticated]);

  // Handle browser storage events (for multi-tab session sync)
  useEffect(() => {
    const handleStorageChange = (e: StorageEvent) => {
      if (e.key === 'cognito-logout' && e.newValue === 'true') {
        // Another tab logged out, sync this tab
        window.location.reload();
      }
    };

    window.addEventListener('storage', handleStorageChange);
    return () => {
      window.removeEventListener('storage', handleStorageChange);
    };
  }, []);
};
